module.exports = __webpack_public_path__ + "static/background-bottom-center-sm-9a580f0d6d4afc9eee7e52a9e5797a72.svg";